import React from "react";
import MaterialIcon from "@material/react-material-icon";
import styled from "@emotion/styled";
import { FolderType } from "./types";

// label boolean changes the styling for icons being used in the right pane
type FolderIconProps = {
  type: FolderType;
  label?: boolean;
};

const folderColor = "#f01716";

const FolderIconElem = styled(MaterialIcon)`
  &.material-icons {
    padding-right: 4px;
    color: ${folderColor};
    margin-bottom: 2px;
  }
`;

const FolderIconLabel = styled(MaterialIcon)`
  &.material-icons {
    padding-right: 8px;
    color: ${folderColor};
    margin-bottom: 2px;
    font-size: 32px;
  }
`;

export const FolderIcon: React.FC<FolderIconProps> = ({ type, label }) => {
  let titleIcon: string;

  switch (type) {
    case "StructuralFolder":
      titleIcon = "folder_copy";
      break;
    case "CustomerFolder":
      titleIcon = "folder_shared";
      break;
    case "ProjectFolder":
      titleIcon = "source";
      break;
    case "GroupedFolder":
      titleIcon = "folder_open";
      break;
    case undefined:
      titleIcon = "";
  }

  if (label === true) {
    return <FolderIconLabel icon={titleIcon} />;
  } else {
    return <FolderIconElem icon={titleIcon} />;
  }
};
